import axios from "axios";
export const getCodeDict = category => {
  return axios.request({
    url: "/api/codeDict/list",
    method: "get",
    params: {
      category
    }
  });
};